import DefaultTemplate from '@templates/DefaultTemplate';

import { useEffect, useRef, useState } from 'react';
import db from '@utils/db';
import { useStore } from '@store/appStore';
import { useAuthentication } from '@providers/AuthProvider';
import { useRouter } from 'next/router';
import moment from 'moment';
import { Wrapper } from '../LeaderPage/LeaderPage.styled';
import Secretary from '@components/Secretary';


export const SchoolSecretaryPage = () => {
  const { client, whoIsLoggedIn, filterDate, settings } = useStore();
  
  return (
    <DefaultTemplate>
      <Wrapper>
        <Secretary />
      </Wrapper>
    </DefaultTemplate>
  );
};

export default SchoolSecretaryPage;
